import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CartaServices } from '../../services';
import { CartaCreateDishProdSelectPage } from '../../carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuPartialCustomizeEditablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 *
 *
 * https://github.com/zefoy/ngx-color-picker
 */

@Component({
    selector: 'page-carta-partial-customize-editable',
    templateUrl: 'carta-partial-customize-editable.html',
})
export class CartaPartialCustomizeEditablePage {
    @Input() carta_uid: any;
    section_order_show: boolean = false;
    section_change_page_show: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public cartaServices: CartaServices,
        public translate: TranslateService,
        public alertCtrl: AlertController) {
    }

    close() {
        this.cartaServices.edit = false;
    }

    update() {
        //Edit section
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_family_sname = this.cartaServices.edit_section.font_family_sname;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_size_sname = Number(this.cartaServices.edit_section.font_size_sname);
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_color_sname = this.cartaServices.edit_section.font_color_sname;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].text_align_sname = this.cartaServices.edit_section.text_align_sname;
        //Edit section
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_family_ename = this.cartaServices.edit_section.font_family_ename;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_size_ename = Number(this.cartaServices.edit_section.font_size_ename);
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_color_ename = this.cartaServices.edit_section.font_color_ename;
        //Edit section
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_family_edescription = this.cartaServices.edit_section.font_family_edescription;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_size_edescription = Number(this.cartaServices.edit_section.font_size_edescription);
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].font_color_edescription = this.cartaServices.edit_section.font_color_edescription;

        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_tmp.pages,
        });
    }

    editElementos() {
        this.cartaServices.getIndexOfPage();

        this.navCtrl.push(CartaCreateDishProdSelectPage, {
            update_state: true,
            carta_uid: this.carta_uid,
            section_index: this.cartaServices.edit_index,
            page_index: this.cartaServices.edit_page_index,
            section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
            section_name: this.cartaServices.edit_section.name,
            new_section: false,
        });
    }

    showElementsOrder() {
        this.cartaServices.edit_elements_array = this.globals.objectToArray(this.cartaServices.edit_section.elements);

        if (!this.cartaServices.elements_order_show) {
            this.cartaServices.elements_order_show = true;
        } else {
            this.cartaServices.elements_order_show = false;
        }
    }

    updateElementsOrder() {

        var _obj = {};
        for (var i = 0; this.cartaServices.edit_elements_array.length > i; i++) {
            _obj[i] = {
                uid: this.cartaServices.edit_elements_array[i].uid,
                order: i + 1,
                type: this.cartaServices.edit_elements_array[i].type,
                name_es: this.cartaServices.edit_elements_array[i].name_es,
                name_ca: this.cartaServices.edit_elements_array[i].name_ca,
                name_en: this.cartaServices.edit_elements_array[i].name_en,
                name_de: this.cartaServices.edit_elements_array[i].name_de,
                name_fr: this.cartaServices.edit_elements_array[i].name_fr,
                name_it: this.cartaServices.edit_elements_array[i].name_it,
                allergens: this.cartaServices.edit_elements_array[i].allergens,
                price: this.cartaServices.edit_elements_array[i].price,
                price_half: this.cartaServices.edit_elements_array[i].price_half,
                price_tapa: this.cartaServices.edit_elements_array[i].price_tapa,
                cost_ration: this.cartaServices.edit_elements_array[i].cost_ration,
                image: this.cartaServices.edit_elements_array[i].image,

            };
        }

        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].elements = _obj;


        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_tmp.pages,
        });
        this.showElementsOrder();
    }

    openNewSection() {
        this.globals.GAtrackView('Cartas', 'Cartas - Section new - Create', this.globals.restaurant.email, 'Create/Update', 'Create section new', 'Cartas', this.carta_uid);
        this.cartaServices.getIndexOfPage();

        var index = this.globals.objectToArray(this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections).length;

        this.navCtrl.push(CartaCreateDishProdSelectPage, {
            update_state: true,
            carta_uid: this.carta_uid,
            section_index: index,
            page_index: this.cartaServices.edit_page_index,
            section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
            section_name: '',
            new_section: true,
        })

    }

    showSectionOrder() {
        if (!this.section_order_show) {
            this.section_order_show = true;
        } else {
            this.section_order_show = false;
            this.cartaServices.getIndexOfPage();
        }
    }

    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.cartaServices.edit_sections.length > i; i++) {
            _obj[i] = {

                name: this.cartaServices.edit_sections[i].name,
                order: this.cartaServices.edit_sections[i].order,
                font_family_sname: this.cartaServices.edit_sections[i].font_family_sname,
                font_size_sname: Number(this.cartaServices.edit_sections[i].font_size_sname),
                font_color_sname: this.cartaServices.edit_sections[i].font_color_sname,
                text_align_sname: this.cartaServices.edit_sections[i].text_align_sname,
                font_family_ename: this.cartaServices.edit_sections[i].font_family_ename,
                font_size_ename: Number(this.cartaServices.edit_sections[i].font_size_ename),
                font_color_ename: this.cartaServices.edit_sections[i].font_color_ename,
                font_family_edescription: this.cartaServices.edit_sections[i].font_family_edescription,
                font_size_edescription: Number(this.cartaServices.edit_sections[i].font_size_edescription),
                font_color_edescription: this.cartaServices.edit_sections[i].font_color_edescription,
                elements: this.cartaServices.edit_sections[i].elements,

            };
        }

        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = _obj;

        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_tmp.pages,
        });


        this.showSectionOrder();
    }

    showChangeSectionPage() {
        if (!this.section_change_page_show) {
            this.section_change_page_show = true;
        } else {
            this.section_change_page_show = false;
        }
    }

    async onChange(new_page, original_page, section, page_index, section_index) {

        //delete section from original page
        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections);

        sections_arr.splice(section_index, 1);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            obj[index] = item;
        })
        this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections = obj;
        //volver a ordernar las secciones
        this.reOrderSectionsDelete(original_page);

        //copy section to new page
        var new_index = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections).length;
        this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections[new_index] = section;
        //volver a ordernar las secciones
        this.reOrderSectionsCreate(new_page);


        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.pages_array_tmp,
        });
    }

    getIndex(page) {
        for (let key in this.cartaServices.pages_array_tmp) {
            if (this.cartaServices.pages_array_tmp[key].number == page) {
                return key;
            }
        }
    }


    reOrderSectionsDelete(original_page) {
        var order = 1;


        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            item.order = order;
            obj[index] = item;
            order++;
        })


        this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections = obj;

    }

    reOrderSectionsCreate(new_page) {
        var order = 1;


        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            item.order = order;
            obj[index] = item;
            order++;
        })


        this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections = obj;
    }


    reorderElements(indexes) {
        let element = this.cartaServices.edit_elements_array[indexes.from];
        this.cartaServices.edit_elements_array.splice(indexes.from, 1);
        this.cartaServices.edit_elements_array.splice(indexes.to, 0, element);
    }

    reorderSections(indexes) {
        let element = this.cartaServices.edit_sections[indexes.from];
        this.cartaServices.edit_sections.splice(indexes.from, 1);
        this.cartaServices.edit_sections.splice(indexes.to, 0, element);
    }

    deleteSection() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //delete
                        delete this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index];


                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = obj_help;




                        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                            'pages': this.cartaServices.carta_tmp.pages,
                        });
                        this.cartaServices.edit = false;
                    }
                }
            ]
        });
        alert.present();

    }



}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-partial-customize-editable/carta-partial-customize-editable.ts